import React, { useState, useEffect, Fragment } from "react";
import {
  IconButton,
  Autocomplete,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import moment from "moment";
//Icons
import DeleteIcon from "@mui/icons-material/Delete";
//Srcs
import "../../Style/dialogstyle.scss";
import { GET_CHART_OF_ACCOUNT_FOR_SELECT } from "../../Schema/SelectSchema";
import ExpenseListComp from "./ExpenseListComp";
import CreateChartOfAccount from "../ChartOfAccount/CreateChartOfAccount";

export default function ListAccountType({
  setUpdateExpenseItem,
  requiredField,
  disbursementList,
  setDisbursementList,
  deleteDisbursementList,
  setUpdateAccountType,
}) {
  const [touched, steTouched] = useState(false);
  const handleTouch = () => steTouched(true);
  let errorMessage = "require!";

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [accountTypeOptions, setAccountTypeOptions] = useState([]);

  const { refetch: refetchAccount } = useQuery(
    GET_CHART_OF_ACCOUNT_FOR_SELECT,
    {
      onCompleted: ({ getChartOfAccountForSelect }) => {
        // console.log("getChartOfAccountForSelect::", getChartOfAccountForSelect);
        let rows = [{ id: "Create", title: "New chart of account" }];
        if (getChartOfAccountForSelect?.length !== 0) {
          getChartOfAccountForSelect?.map((d) => {
            const allRows = {
              id: d?._id,
              title: d?.code_account + " - " + d?.chartOfAccount,
            };
            rows.push(allRows);
            setAccountTypeOptions(rows);
          });
        } else {
          setAccountTypeOptions([]);
        }
      },
      onError: (error) => {
        console.error("Error", error?.message);
      },
    }
  );

  useEffect(() => {
    refetchAccount();
  }, []);

  //============================ Start list Expense ===============================
  const [expenseRequiredField, setExpenseRequiredField] = useState(false);

  const [currentExpense, setCurrentExpense] = useState({
    mainKey: "",
    invDate: "",
    invNo: "",
    description: "",
    supplierId: "",
    supplierName: "",
    qty: 0,
    exchangeRate: 0,
    priceKHR: 0,
    priceUSD: 0,
    key: "",
  });
  const [expenseList, setExpenseList] = useState([]);

  const addExpense = () => {
    let newExpense = currentExpense;
    if (newExpense !== 0) {
      const items = [...expenseList, newExpense];
      setExpenseList([...items]);
      setCurrentExpense({
        mainKey: "",
        invDate: moment(),
        invNo: "",
        description: "",
        supplierId: "",
        supplierName: "",
        qty: 0,
        exchangeRate: 0,
        priceKHR: 0,
        priceUSD: 0,
        key: "",
      });
    }
  };

  useEffect(() => {
    if (currentExpense?.key !== "") {
      addExpense();
    }
  }, [currentExpense]);

  //============================ End list Expense ===============================

  const ListItems = disbursementList?.map((item) => {
    // console.log("big_item::", item);
    return (
      <Fragment key={item?.key}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ paddingBottom: "20px" }}
        >
          <Stack direction="column" spacing={0.5} sx={{ width: "96%" }}>
            <Stack direction="row" spacing={2}>
              <Stack direction="column" justifyContent="center">
                <Typography className="list-title-kh">ប្រភេទគណនី</Typography>
              </Stack>
              <Autocomplete
                sx={{ width: "300px" }}
                disablePortal
                options={accountTypeOptions}
                value={{
                  id: item?.accountTypeId,
                  title: item?.accountTypeName,
                }}
                onChange={(e, value) => {
                  if (value?.id === "Create") {
                    handleOpen();
                  } else {
                    setUpdateAccountType(value?.id, value?.title, item?.key);
                  }
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                getOptionLabel={(option) =>
                  option.title === undefined ? "" : option.title
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="disbursement-field"
                    size="small"
                    placeholder="expense type"
                    onFocus={handleTouch}
                    error={
                      (touched && item?.accountTypeId === undefined) ||
                      (requiredField && item?.accountTypeId === "") ||
                      (requiredField && item?.accountTypeId === undefined)
                    }
                    helperText={
                      (touched &&
                        item?.accountTypeId === undefined &&
                        errorMessage) ||
                      (requiredField &&
                        item?.accountTypeId === "" &&
                        errorMessage) ||
                      (requiredField &&
                        item?.accountTypeId === undefined &&
                        errorMessage)
                    }
                  />
                )}
              />
            </Stack>

            <ExpenseListComp
              setUpdateExpenseItem={setUpdateExpenseItem}
              disbursementList={disbursementList}
              setDisbursementList={setDisbursementList}
              mainItem={item}
              setExpenseList={setExpenseList}
              setCurrentExpense={setCurrentExpense}
              requiredField={expenseRequiredField}
              setRequiredField={setExpenseRequiredField}
            />
          </Stack>

          <Stack direction="column" justifyContent="center">
            <IconButton onClick={() => deleteDisbursementList(item?.key)}>
              <DeleteIcon sx={{ color: "red" }} />
            </IconButton>
          </Stack>
        </Stack>
      </Fragment>
    );
  });

  return (
    <div>
      <CreateChartOfAccount
        open={open}
        handleClose={handleClose}
        setRefetch={refetchAccount}
      />

      {ListItems}
    </div>
  );
}
